import moment from 'moment'

export default (date: string | Date): string => moment(date).format('ddd, MMM D, YYYY')
